'use strict';

exports.__esModule = true;
exports.TimelineItem = undefined;

var _class, _temp2;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _verticalTimelineComponentForReact = require('vertical-timeline-component-for-react');

var _ = require('../../..');

var _2 = _interopRequireDefault(_);

var _ListView = require('../../Connectors/Connector/ListView');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactVisibilitySensor = require('react-visibility-sensor');

var _reactVisibilitySensor2 = _interopRequireDefault(_reactVisibilitySensor);

var _3 = require('..');

var _4 = _interopRequireDefault(_3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TimelineItem = exports.TimelineItem = function (_TimelineItemProto) {
  _inherits(TimelineItem, _TimelineItemProto);

  function TimelineItem() {
    _classCallCheck(this, TimelineItem);

    return _possibleConstructorReturn(this, _TimelineItemProto.apply(this, arguments));
  }

  TimelineItem.prototype.render = function render() {
    var _props = this.props,
        id = _props.id,
        children = _props.children,
        dateText = _props.dateText,
        dateStyle = _props.dateStyle,
        DateComponent = _props.dateComponent,
        dateInnerStyle = _props.dateInnerStyle,
        bodyContainerStyle = _props.bodyContainerStyle,
        style = _props.style,
        className = _props.className,
        visibilitySensorProps = _props.visibilitySensorProps;
    var visible = this.state.visible;
    var isSSR = typeof window === "undefined";
    return _react2.default.createElement('div', {
      id: id,
      className: (0, _classnames2.default)(className, 'entry', {
        'timeline-item--no-children': children === ''
      }),
      style: style
    }, _react2.default.createElement(_reactVisibilitySensor2.default, _extends({}, visibilitySensorProps, {
      onChange: this.onVisibilitySensorChange
    }), _react2.default.createElement(_react.Fragment, null, _react2.default.createElement('div', {
      className: 'title'
    }, _react2.default.createElement('div', {
      className: '' + (visible || isSSR ? 'bounce-in' : 'is-hidden')
    }, DateComponent ? typeof DateComponent === "function" ? _react2.default.createElement(DateComponent, null) : DateComponent : _react2.default.createElement('span', {
      style: dateStyle,
      className: 'timeline-item-date'
    }, _react2.default.createElement('time', {
      style: dateInnerStyle,
      className: 'timeline-item-dateinner',
      title: dateText
    }, dateText)))), _react2.default.createElement('div', {
      className: 'body'
    }, _react2.default.createElement('div', {
      className: 'body-container ' + (visible || isSSR ? 'bounce-in' : 'is-hidden'),
      style: bodyContainerStyle
    }, children)))));
  };

  return TimelineItem;
}(_verticalTimelineComponentForReact.TimelineItem);

var VerticalTimelineItem = (_temp2 = _class = function (_EditorComponent) {
  _inherits(VerticalTimelineItem, _EditorComponent);

  function VerticalTimelineItem() {
    var _temp, _this2, _ret;

    _classCallCheck(this, VerticalTimelineItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, _EditorComponent.call.apply(_EditorComponent, [this].concat(args))), _this2), _this2.onBeforeDrop = function () {}, _this2.renderRoot = function (props) {
      var style = props.style,
          dateText = props.dateText,
          dateStyle = props.dateStyle,
          dateInnerStyle = props.dateInnerStyle,
          dateComponent = props.dateComponent,
          bodyContainerStyle = props.bodyContainerStyle,
          visibilitySensorProps = props.visibilitySensorProps,
          other = _objectWithoutProperties(props, ['style', 'dateText', 'dateStyle', 'dateInnerStyle', 'dateComponent', 'bodyContainerStyle', 'visibilitySensorProps']);

      return _react2.default.createElement(TimelineItem, {
        style: style,
        dateText: dateText,
        dateStyle: dateStyle,
        dateInnerStyle: dateInnerStyle,
        dateComponent: dateComponent,
        bodyContainerStyle: bodyContainerStyle,
        visibilitySensorProps: visibilitySensorProps
      }, _react2.default.createElement('div', other));
    }, _this2.renderDateComponent = function () {
      var object = _this2.getObjectWithMutations();

      var _ref = object || {},
          components = _ref.components;

      var _this2$getComponentPr = _this2.getComponentProps(_this2),
          backgroundColor = _this2$getComponentPr.backgroundColor;

      return _react2.default.createElement('div', {
        className: 'timeline-item-date',
        style: {
          position: "relative",
          zIndex: 100,
          clipPath: "unset",
          display: "flex",
          flexDirection: "row",
          background: "transparent",
          whiteSpace: "nowrap"
        }
      }, _react2.default.createElement('div', {
        className: 'timeline-item-dateinner',
        style: {
          clipPath: "unset",
          flex: 1,
          backgroundColor: backgroundColor ? backgroundColor : "transparent"
        }
      }, components && components.length ? _this2.renderComponent(components[0]) : null), _react2.default.createElement('div', {
        style: backgroundColor ? {
          "width": "0",
          "height": "0",
          "borderStyle": "solid",
          "borderWidth": "25px 0 25px 10px",
          "borderColor": 'transparent transparent transparent ' + backgroundColor
        } : undefined
      }));
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  } // canBeDropped = (dragItem) => {
  //   return false;
  // }


  VerticalTimelineItem.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelVerticalTimelineItem
    }, 'VerticalTimelineItem'));
  }; // getRootElement() {
  //   return VerticalTimelineItemComponent
  // }


  VerticalTimelineItem.prototype.getRootElement = function getRootElement() {
    return this.renderRoot;
  };

  VerticalTimelineItem.prototype.renderMainView = function renderMainView() {
    var _this3 = this;

    return _react2.default.createElement(_ListView.ObjectContext.Consumer, null, function (context) {
      var object = context.object;
      return _EditorComponent.prototype.renderMainView.call(_this3, {
        object: object,
        dateComponent: _this3.renderDateComponent
      });
    });
  };

  VerticalTimelineItem.prototype.getComponents = function getComponents(itemComponents) {
    return itemComponents && itemComponents.length ? itemComponents.slice(1) : [];
  };

  VerticalTimelineItem.prototype.canBeParent = function canBeParent(parent) {
    return parent instanceof _4.default && _EditorComponent.prototype.canBeParent.call(this, parent);
  };

  return VerticalTimelineItem;
}(_2.default), _class.defaultProps = _extends({}, _2.default.defaultProps, {
  label: undefined,
  helperText: undefined,
  readOnly: true,
  backgroundColor: "#76bb7f"
}), _class.Name = "VerticalTimelineItem", _class.help_url = "https://front-editor.prisma-cms.com/topics/verticaltimeline.html", _temp2);
exports.default = VerticalTimelineItem;